import React, { forwardRef } from 'react';

import { TemplateNumberFormatInput } from '../../../Components';

const PesoInput = forwardRef((props, ref) => (
  <TemplateNumberFormatInput {...props} escala={2} sufixo="m2" ref={ref} />
));

export default PesoInput;
